import script from "./ErrorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__